// 徽章等级定义（按积分从低到高），与后端 BadgeLevel 保持一致
// 图标：叶芽 / 罗盘 / 放大镜 / 树枝 / 谱册 / 毛笔 / 盾牌 / 火炬
export const BADGE_LEVELS = [
  { level: 1, name: '新叶初萌', icon: '🌱', minPoints: 0 },
  { level: 2, name: '寻根初探', icon: '🧭', minPoints: 50 },
  { level: 3, name: '记忆拾穗', icon: '🔍', minPoints: 150 },
  { level: 4, name: '支脉梳理', icon: '🌿', minPoints: 300 },
  { level: 5, name: '守谱使者', icon: '📖', minPoints: 600 },
  { level: 6, name: '家族史官', icon: '🖌️', minPoints: 1000 },
  { level: 7, name: '根脉守护', icon: '🛡️', minPoints: 1600 },
  { level: 8, name: '传承火炬', icon: '🔥', minPoints: 2500 }
]

/**
 * 按积分本地换算徽章（后端未返回徽章字段时的兜底逻辑）
 */
export function resolveBadgeByPoints(points) {
  const value = Number(points) || 0
  let current = BADGE_LEVELS[0]
  for (const badge of BADGE_LEVELS) {
    if (value >= badge.minPoints) {
      current = badge
    } else {
      break
    }
  }
  return current
}

/**
 * 解析用户徽章：优先使用后端返回的徽章字段（保证前后端规则一致），
 * 仅在缺少徽章字段时才用积分兜底，避免阈值改动后两边展示不一致
 */
export function resolveUserBadge(user) {
  if (!user) return null
  if (user.badgeName) {
    return {
      level: user.badgeLevel,
      name: user.badgeName,
      icon: user.badgeIcon,
      nextName: user.nextBadgeName,
      nextPoints: user.nextBadgePoints
    }
  }
  if (user.points === undefined || user.points === null) return null
  return resolveBadgeByPoints(user.points)
}
